import gql from 'graphql-tag'

const EMPLOYEE_DATA = `
    id
    uid
    email
    name
    last_name
    sex
    sex_text
    status_text
    mothers_last_name
    document_type
    document_number
    phone_number
    phone_number_ref
    current_address
    ref_address
    document_address
    academic_level
    titles_obtained
    date_birth
    work_start_date
    trusted_person
    state_id
    produccion
    asistencia
    responsabilidad
    reintegro
    adicional
    state {
        name
    }
    city_id
    city {
        name
    }
    district_id
    district {
        name
    }
    concubine_type
    has_children
    is_active
    concubine {
        id
        name
        last_name
        document_type
        document_number
        phone_number
        date_birth
    }
    cessation {
        id
        employee_id
        reason_id
        reason {
            id
            name
        }
        date
        type
        description
    }
    assignment {
        id
        cost_center_id
        position_id
        headquarter_id
        area_id
        sub_area_id
        work_shift_id
        work_category
        work_type
        type_of_contract
        condition
        labor_regime
        contrato_number
        lunch
        lunch_rate_id
        lunch_rate {
            name
            price
        }
        cost_center {
            name
        }
        position {
            name
        }
        headquarter {
            name
        }
        area {
            name
        }
        sub_area {
            id
            name
            description
            is_active
            status_text
            is_group_piecework
        }
        work_shift {
            id
            name
            is_cumulative
            is_nocturnal
            checkin_time
            checkout_time
            lunch_time_entry
            lunch_time_ends
        }
        fixed_dialing
    }
    finance {
        id
        bank
        telecredito
        tipo_cuenta
        moneda
        account_number
        family_allowance
        regular_bonus
        base_salary
        payment_frequency
        regular_amount
        ordinary_perks
        bank_cts
        account_number_cts
    }
    insurance {
        id
        afp_id
        afp {
            name
        }
        life_insurance
        rent
        right_environment
        agricultural_insurance
        sctr_life
        eps
        cussp
        sctr_pension
        sctr_pension_description
        type_of_commission
        gratification
        type_regime
        date_afp
        sctr_health
        regular_insurance
        insuranceCompany {
            id
            name
        }
    }
    children {
        id
        name
        last_name
        document_type
        document_number
        date_birth
    }
    bono {
        id
        bond_type_id
        amount
    }
    tiposbono {
        id
        name
    }
`

/**
 * Query
 */
const GET_ACTIVATED = gql`
    query employeesActivated {
        employeesActivated {
            id
            name
            fullName
            last_name
            mothers_last_name
            email
            phone_number
            document_type
            document_number
            work_start_date
            is_active
            assignment {
                area_id
                sub_area_id
                headquarter_id
                lunch
                lunch_rate_id
            }
            cessation {
                id
                employee_id
                reason_id
                reason {
                    id
                    name
                }
                date
                type
                description
            }
        }
    }
`

const GET_ALL = gql`
    query employees ($filters: FiltersEmployee) {
        employees (filters: $filters) {
            ${EMPLOYEE_DATA}
        }
    }
`

const GET_WITH_PAGINATION = gql`
    query employeesWithPagination ($perPage: Int!, $page: Int!, $filters: FiltersEmployee!){
        employeesWithPagination (first: $perPage, page: $page, filters: $filters) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                uid
                name
                last_name
                fullName
                email
                phone_number
                document_type
                document_number
                devices {
                    device {
                        name
                    }
                }
                assignment {
                    work_category
                    type_of_contract
                    position {
                        id
                        name
                    }
                }
                insurance {
                    afp {
                        id
                        name
                    }
                }
                is_active
                status_text
            }
        }
    }
`

const GET_ALL_BY_ID = gql`
    query employee ($id: ID!) {
        employee (id: $id) {
            id
            uid
            email
            name
            last_name
            sex
            mothers_last_name
            document_type
            document_number
            phone_number
            phone_number_ref
            current_address
            ref_address
            document_address
            academic_level
            titles_obtained
            date_birth
            work_start_date
            trusted_person
            state_id
            city_id
            district_id
            concubine_type
            has_children
            is_active
            produccion
            asistencia
            responsabilidad
            reintegro
            adicional
            concubine {
                id
                name
                last_name
                document_type
                document_number
                phone_number
                date_birth
            }
            assignment {
                id
                cost_center_id
                position_id
                headquarter_id
                area_id
                sub_area_id
                work_shift_id
                work_category
                work_type
                type_of_contract
                condition
                labor_regime
                contrato_number
                lunch
                lunch_rate_id
                lunch_rate {
                    name
                    price
                }
                cost_center {
                    name
                }
                position {
                    name
                }
                headquarter {
                    name
                }
                area {
                    name
                }
                sub_area {
                    id
                    name
                    description
                    is_active
                    status_text
                    is_group_piecework
                }
                work_shift {
                    id
                    name
                    is_cumulative
                    is_nocturnal
                    checkin_time
                    checkout_time
                    lunch_time_entry
                    lunch_time_ends
                }
                fixed_dialing
            }
            finance {
                id
                bank
                telecredito
                tipo_cuenta
                moneda
                account_number
                family_allowance
                regular_bonus
                base_salary
                payment_frequency
                regular_amount
                ordinary_perks
                bank_cts
                account_number_cts
            }
            insurance {
                id
                afp_id
                insurance_company_id
                life_insurance
                rent
                right_environment
                agricultural_insurance
                sctr_life
                eps
                cussp
                sctr_pension
                sctr_pension_description
                type_of_commission
                gratification
                type_regime
                date_afp
                sctr_health
                regular_insurance
            }
            plame {
                id
                ensures_pension
                essalud
                domiciled
            }
            children {
                id
                name
                last_name
                document_type
                document_number
                date_birth
            }
            bono {
                id
                bond_type_id
                amount
            }
            tiposbono {
                id
                name
            }
        }
    }
`
const GET_NEXT_CODE = gql`
    query getNextCode {
        getNextCode {
            code
        }
    }
`

const VALIDATE_CODE = gql`
    query validateCodeEmployee ($input: ValidateCodeEmployee!) {
        validateCodeEmployee (input: $input) {
            success
            code
            msg
        }
    }
`

const GET_INFO_DEVICES = gql`
    query getInfoEmployeeDevices ($id: ID!) {
        getInfoEmployeeDevices (id: $id) {
            id
            device_id
            password
            uid
            name
        }
    }
`

const GET_SUMMARY = gql`
    query getSummaryEmployees {
        getSummaryEmployees {
            total
            active
            inactive
            employees {
                id
                sex
            }
        }
    }
`

const GET_BIRTHDAYS_PER_MONTH = gql`
    query birthdaysPerMonth($month: Int!) {
        birthdaysPerMonth (month: $month) {
            id
            email
            name
            last_name
            sex
            mothers_last_name
            document_type
            document_number
            phone_number
            date_birth
        }
    }
`

/**
 * Mutations
 */
const CREATE_EMPLOYEE = gql`
    mutation createEmployee ($input: CreateEmployeeInput!){
        createEmployee (input: $input) {
            id
            name
            email
        }
    }
`

const UPDATE_STATUS = gql`
    mutation updateStatusEmployee ($id: ID!, $input: UpdateStatusEmployee!){
        updateStatusEmployee (id: $id, input: $input) {
            id
            name
            email
        }
    }
`

const UPDATE = gql`
    mutation updateEmployee ($id: ID!, $input: CreateEmployeeInput!){
        updateEmployee (id: $id, input: $input) {
            id
            name
            email
        }
    }
`

const DELETE = gql`
    mutation deleteEmployee ($id: ID!){
        deleteEmployee (id: $id) {
            id
            name
            email
        }
    }
`

const UPDATE_DEVICES = gql`
    mutation updateDevicesEmployee ($id: ID!, $input: EmployeeUpdateDevices!) {
        updateDevicesEmployee (id: $id, input: $input) {
            success
            error
            msgError
        }
    }
`

export {
    CREATE_EMPLOYEE,
    GET_WITH_PAGINATION,
    GET_ACTIVATED,
    UPDATE_STATUS,
    DELETE,
    GET_ALL_BY_ID,
    UPDATE,
    GET_NEXT_CODE,
    VALIDATE_CODE,
    UPDATE_DEVICES,
    GET_INFO_DEVICES,
    GET_SUMMARY,
    GET_ALL,
    GET_BIRTHDAYS_PER_MONTH,
    EMPLOYEE_DATA
}
